<template>
  <div>
    <PageHeader title="Confirm Email"></PageHeader>
    <v-container class="page-bottom">
      <v-row>
        <v-col>
          <div class="pb-4">
            Check your inbox at <b>{{user.email}}</b> for the confirmation code we just sent you.
          </div>
          <div style="color: #ffb300;" class="pb-3">
            <v-icon
                left
                dark
                small
                color="#ffb300"
              >
                mdi-alert
              </v-icon> Check your Spam folder as well.
          </div>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="validate"
          >
            <v-text-field
              v-model="user.userName"
              :rules="[rules.required]"
              label="User name"
              required
            ></v-text-field>

            <v-text-field
              v-model="user.code"
              :rules="[rules.required]"
              label="Code"
              required
              type="number"
            ></v-text-field>

            <v-btn
              block
              outlined
              large
              style="color: #ffffff !important;border: 1px solid #ffb300;"
              :disabled="!valid"
              color="success"
              class="mt-5"
              type="submit"
            >
              Confirm Email
            </v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      centered
      color="error"
    >
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>  
    <Spinner :overlay="overlay"></Spinner>
  </div>
</template>

<script>
import { CognitoUser } from "amazon-cognito-identity-js";
import PageHeader from './../../components/PageHeader';
import Spinner from './../../components/Spinner';
import UserPool from "./../../plugins/UserPool";

export default {
  name: 'confirm',
  components: {
    PageHeader,
    Spinner
  },
  data: () => ({
    valid: true,
    user: null,
    rules: {
      required: value => !!value || 'Required.'
    },
    overlay: false,
    absolute: true,
    snackbar: false,
    snackbarText: ''
  }),
  methods: {
    validate () {
      var scope = this;
      var isValid = scope.$refs.form.validate();
      if(isValid){
        scope.overlay = true;
        scope.join();
      }
    },
    join () {
      var scope = this;
      scope.overlay = true;

      const user = new CognitoUser({
        Username: scope.user.userName,
        Pool: UserPool
      });

      user.confirmRegistration(scope.user.code, true, (err) => {
        if (err) {
          console.log("onFailure: ", err);
          scope.overlay = false;
          scope.snackbarText = err.message;
          scope.snackbar = true;
        } else {
          scope.overlay = false;
          scope.$router.push({name: 'login', query: {userName: scope.user.userName}});
        }
      });
    }
  },
  created () {
    this.user = {
      email: this.$route.query.email,
      userName: this.$route.query.userName,
      code: this.$route.query.code
    }
  }
}
</script>